import { STATUS_TO_API_VALUE } from "../config/MilestoneInvoice.constants";
import { IApiInvoiceItem, IApiMilestoneItem, IInvoiceFilterApiItem } from "../services/milestoneTrackerApi";
import { toAmount } from "./maskedValue";


/** Maps a filtered-invoice API item (from the invoice search endpoint) into a table row. */
export function mapApiInvoiceToTrackerRow(item) {
  return {
    invoiceId: item.invoiceId || "-",
    sowId: item.sowId || "-",
    projectId: item.projectId || "-",
    accountName: item.accountName || "-",
    revenueMonth: item.revenueMonth || "-",
    invoiceSubmittedDate: item.invoiceSubmittedDate || "-",
    grossInvoiceAmount: toAmount(item.invoiceAmount),
    currencyType: item.currencyType,
    approvalStatusInFieldglass: item.approvalStatusInFG,
    invoicingStatus: item.invoicingStatusInUST || undefined,
    reason: item.reason || null,
    milestoneName: "-",
  };
}

export function mapMilestoneToTableRow (item) {
  return {
    ...item,
    accountId: item.accountId || item.accountName || "-",
    amount: toAmount(item.amount ?? item.milestoneAmount),
    role: item.role || "-",
    manager: item.manager || item.managerName || "-",
    startDate: item.startDate || item.milestoneStartDate || "-",
    endDate: item.endDate || item.milestoneEndDate || "-",
    milestoneId: item.milestoneId||"-"
  };
};

export function mapInvoiceToTrackerRow(
  item,
  index,
){
  const submitted = Boolean(item.invoiceSubmittedDate);
  const status = toUiInvoiceStatus(
    item.approvalStatusInFieldglass,
    item.invoicingStatus,
    submitted,
  );

  return {
    id: item.invoiceId || `invoice-${index}`,
    sowId: item.sowId || "-",
    projectId: item.projectId || "-",
    managerName: item.managerName || "-",
    account: item.accountName || "-",
    milestoneName: item.milestoneName || item.invoiceId || "-",
    acceptanceCriteria: "-",
    milestoneStartDate: item.revenueMonth || "-",
    milestoneEndDate: item.invoiceSubmittedDate || item.revenueMonth || "-",
    milestoneAmount: toAmount(item.grossInvoiceAmount),
    invoiceSubmitted: submitted ? "Y" : "N",
    submittedDate:  item.revenueMonth,
    invoiceStatus: status,
    pendingReason: item.reason || "",
  };
};
export function normalizeInvoices(
  invoices,
  fallbackProjectId,
) {
  return invoices.map((invoice) => ({
    ...invoice,
    projectId: invoice.projectId || fallbackProjectId,
    grossInvoiceAmount: toAmount(
      invoice.grossInvoiceAmount ?? invoice.invoiceAmount,
    ),
    approvalStatusInFieldglass:
      invoice.approvalStatusInFG,
    invoicingStatus: invoice.invoicingStatus || invoice.invoicingStatusInUST,
  }));
}

export function toUiInvoiceStatus (
  approvalStatusInFieldglass,
  invoicingStatus,
  hasSubmittedDate,
) {
  const approval = (approvalStatusInFieldglass || "").trim().toLowerCase();
  const invoicing = (invoicingStatus || "").trim().toLowerCase();

  if (approval === "approved") return "Approved";
  if (approval === "rejected") return "Rejected";
  if (
    invoicing.includes("pending") ||
    invoicing.includes("hold") ||
    invoicing.includes("dispute")
  ) {
    return "Pending";
  }
  if (
    hasSubmittedDate ||
    invoicing.includes("invoiced") ||
    invoicing.includes("submitted")
  ) {
    return "In Review";
  }
  return "Not Submitted";
};

export function toFieldglassStatus(
  approvalStatusInFieldglass,
  invoicingStatus
){
  const approval = (approvalStatusInFieldglass || "").trim().toLowerCase();
  const invoicing = (invoicingStatus || "").trim().toLowerCase();

  if (approval.includes("rejected")) {
    return "Rejected";
  }

  if (approval.includes("invoiced") || approval.includes("approved")) {
    return "Invoiced";
  }

  if (approval.includes("pending") || approval.includes("approval")) {
    return "Pending Approval";
  }

  if (invoicing.includes("rejected")) {
    return "Rejected";
  }

  if (invoicing.includes("invoiced") || invoicing.includes("submitted")) {
    return "Invoiced";
  }

  return "Pending Approval";
};

export function formatDisplayDate(value){
  if (!value) return "-";

  // Handle ISO-like dates first: YYYY-MM-DD or YYYY/MM/DD
  const isoMatch = /^(\d{4})[-/](\d{2})[-/](\d{2})$/.exec(value);
  if (isoMatch) {
    const [, year, month, day] = isoMatch;
    return `${month}-${day}-${year}`;
  }
   const usMatch = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(value);
    if (usMatch) {
      const [, month, day, year] = usMatch;
      const dd = day.padStart(2, "0");
      const mm = month.padStart(2, "0");
      return `${mm}-${dd}-${year}`;
    }
  
    return value;
  };
  export const resolveInvoiceStatusOption = (invoice) => {
  const invoicingStatus = (invoice?.invoicingStatus || "").trim();
  if (STATUS_TO_API_VALUE[invoicingStatus]) {
    return invoicingStatus;
  }

  const approvalStatus = (invoice?.approvalStatusInFieldglass || "").trim();
  if (STATUS_TO_API_VALUE[approvalStatus]) {
    return approvalStatus;
  }

  return undefined;
};